export function logJSONtagData(message, elemId) {
  console.log(message ?? `${message}:`, getSlidesDataById(elemId));
}

export function getSlidesDataById(nodeId) {
  return JSON.parse(document.getElementById(nodeId).textContent);
}

export function sortVendorsByAlphabet(vendors) {
  return [...vendors].sort((a, b) => ("" + a.name).localeCompare(b.name));
}


/**
 * Executes after all 
 * @param func 
 */
export function onLoad(func) {
  window.addEventListener("load", function() { 
    func();
  });
}

/**
 * Executes the function after html is parsed and dom is ready
 * @param func function to execute
 */
export function onDOMLoad(func) {
  document.addEventListener("DOMContentLoaded", function() { 
    func();
  });
}

export function clickToActivate() {
  let selfDestruct: (this: Element, ev: Event) => any = (e) =>{
    let element = e.currentTarget as HTMLDivElement;
    element.remove();
  }
  let elements = document.getElementsByClassName("click-to-activate");
  Array.from(elements).forEach(item =>{
    item.addEventListener("click", selfDestruct )
  })
}

$(()=>{
  clickToActivate()
})
